<script>

    import {onMount} from "svelte";
    import {GET, POST} from "../../components/communication";
    import {
        parseTimestampStr,
        firstAndLastDateOfJSDate,
        JsDate2ISODateStr,
        plusDate,
        JsDate2DateTimeStr, parseTimestampStrToDateTime, isToday
    } from "../../components/utils";
    import {userData} from "../../components/stores.js";
    import {navigate} from "svelte-routing";

    let loadingData = false;
    let savingData = false;
    let fullFastEntry = false;
    let currentlyFasting = false;
    let fastingEndedToday = false;
    let fastId = null;
    let fastingData = null;
    let averageHours, averageMinutes;
    // Haetaan kuukauden ajalta paastot raporttiin
    let searchFromDate = JsDate2ISODateStr(firstAndLastDateOfJSDate(new Date())[0]);
    let searchToDate = JsDate2ISODateStr(firstAndLastDateOfJSDate(new Date())[1]);

    let fromDate = plusDate(new Date(), -1);
    let fromDateStr = JsDate2ISODateStr(fromDate);
    let toDate = new Date();
    let toDateStr = JsDate2ISODateStr(toDate);
    let fromHours = "20";
    let fromMinutes = "00";
    let toHours = "12";
    let toMinutes = "00";
    // Lasketaan annetuista ajoista, että kauanko paasto kestää
    let fastingTime = null;

    let newFast = {
        startTime: "",
        endTime: "",
        contactid: null
    };

    onMount(async function () {
        console.log("onMount");
        getData();
    });

    async function getData() {
        console.log("getData");
        if ($userData && $userData.id) {
            loadingData = true;
            const response = GET("/c/getFastingTimes?id=" + $userData.id + "&fromDate=" + searchFromDate + "&toDate=" + searchToDate);
            const data = await response;
            console.log("getData :: data: ", data);
            if (data) {
                fastingData = data;
                newFast.contactid = $userData.id;
                // Jos viimeisin paasto on kesken, niin asetetaan se aloitukseksi
                if (fastingData.length > 0) {
                    if (fastingData[fastingData.length - 1].endTime === null) {
                        currentlyFasting = true;
                        newFast.startTime = fastingData[fastingData.length - 1].startTime;
                        fastId = fastingData[fastingData.length - 1].id;
                    }

                    // Lasketaan keskimääräisen paaston kesto
                    let totalMillis = 0;
                    let totalMinutes = 0;
                    for (let i = 0; i < fastingData.length; i++) {
                        const millis = countMillisFromTimestamps(fastingData[i].startTime, fastingData[i].endTime);
                        totalMillis += millis;

                        // Päätellään samalla, että onko käsiteltävän paaston loppuaika tämän päivän puolella
                        console.log("new Date(fastingData[i].endTime)", new Date(fastingData[i].endTime));
                        if (fastingData[i].endTime && isToday(new Date(fastingData[i].endTime))) {
                            fastingEndedToday = true;
                        }
                    }
                    const averageMillis = Math.floor(totalMillis / fastingData.length);
                    averageHours = Math.floor(averageMillis / (1000 * 60 * 60));
                    averageMinutes = Math.floor((averageMillis % (1000 * 60 * 60)) / (1000 * 60));


                }
            }
            loadingData = false;
        } else {
            // Koodatessa ja selaimen automaattisella päivityksellä käyttäjän tietoja ei haieta
            // Automaattisesti, joten tänne tullaan aivan liian usein. Siksi automatic redirect
            console.log("getData :: userData puuttuu");
            navigate('/c/home', { replace: false });
        }
    }

    // Lasketaan, että monta tuntia on kahden timestampin välissä
    function countHoursAndMinutesFromTimestamps(startTime, endTime) {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const diff = Math.abs(end - start);
        // Lasketaan tunnit ja minuutit

        //const hours = (diff / 1000 / 60 / 60);
        //return hours;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return {hours, minutes};
    }

    function countMillisFromTimestamps(startTime, endTime) {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const diff = Math.abs(end - start);
        return diff;
    }

    function dateChanged() {
        console.log("dateChanged :: newFast.date: ", newFast.date);
    }

    // Luodaan tuntien valinta varten taulukko, joka sisältää tunnit 0-23
    let hours = Array.from({length: 24}, (_, i) => i < 10 ? `0${i}` : `${i}`);
    console.log("hours:", hours);


    function calculateFast() {
        console.log("calculateFast :: newFast: ", newFast);
        console.log("calculateFast :: fromDateStr", fromDateStr);
        console.log("calculateFast :: fromHours", fromHours);
        console.log("calculateFast :: fromMinutes", fromMinutes);
        console.log("calculateFast :: toDateStr", toDateStr);
        console.log("calculateFast :: toHours", toHours);
        console.log("calculateFast :: toMinutes", toMinutes);

        newFast.startTime = new Date(fromDateStr);
        //Asetetaan vielä tunnit ja minuutit
        newFast.startTime.setHours(fromHours);
        newFast.startTime.setMinutes(fromMinutes);

        newFast.endTime = new Date(toDateStr);
        //Asetetaan vielä tunnit ja minuutit
        newFast.endTime.setHours(toHours);
        newFast.endTime.setMinutes(toMinutes);

        fastingTime = countHoursAndMinutesFromTimestamps(newFast.startTime, newFast.endTime);
        console.log("calculateFast :: fastingTime", fastingTime);
    }

    async function saveFast() {
        console.log("saveFast");
        if ($userData && $userData.id) {
            newFast.contactid = $userData.id;
            console.log("saveFast :: newFast: ", newFast);
            savingData = true;
            const response = POST("/c/saveFastingTime", JSON.stringify(newFast));
            const data = await response;
            console.log("saveFast :: data: ", data);
            if (data) {
                // Jos kaikki menee putkeen, niin haetaan listaan datat uusiksi
                fastId = data.id;
                getData();
            } else {
                console.log("VIRHE :: data: ", data);
            }
            savingData = false;
        } else {
            console.log("getData :: userData puuttuu");
        }
    }

    function openFullFastEntry() {
        fullFastEntry = (fullFastEntry === true) ? false : true;
        console.log("openFullFastEntry :: ", fullFastEntry);
    }

    function startFast() {
        console.log("startFast");
        currentlyFasting = true;
        newFast.startTime = new Date();
        newFast.contactid = $userData.id;
        newFast.id = null;
        saveFast();
    }

    function endFast() {
        console.log("endFast :: fastId", fastId);
        if (fastId) {
            currentlyFasting = false;
            newFast.id = fastId;
            newFast.endTime = new Date();
            newFast.contactid = $userData.id;
            saveFast();
        } else {
            console.log("endFast :: fastId puuttuu");
        }
    }

    async function deleteFast(id) {
        console.log("deleteFast :: id: ", id);
        const response = GET("/c/deleteFastingTime?id=" + id);
        const data = await response;
        console.log("deleteFast :: data: ", data);
        if (data) {
            getData();
        }

    }

    function editFast(f) {
        console.log("editFast :: fast: ", f);

        // Jos endTime on null, niin asetetaan kuluva päivä
        if (f.endTime === null) {
            f.endTime = new Date();
        }

        const startD = new Date(f.startTime);
        const endD = new Date(f.endTime);
        fromDateStr = JsDate2ISODateStr(startD);
        fromHours = startD.getHours().toString();
        fromMinutes = startD.getMinutes().toString();
        toDateStr = JsDate2ISODateStr(endD);
        toHours = endD.getHours().toString();
        toMinutes = endD.getMinutes().toString();
        fastId = f.id;
        fullFastEntry = true;
        newFast.startTime = new Date(f.startTime);
        newFast.endTime = new Date(f.endTime);
        newFast.contactid = f.contactid;
        newFast.id = f.id;
        // Lasketaan kesto, jos se onnistuisi vaikka
        calculateFast();
    }

</script>
<div class="page">
    {#if $userData && $userData.id}
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="page-title">
                        <h3>Paastoaikalaskuri</h3>
                    </div>
                </div>
            </div>
            <div class="row">
                {#if !currentlyFasting}
                    <button class="btn btn-primary" on:click={startFast}>Aloita paasto</button>
                {:else}
                    <!-- Ei näytetä lopetuspainiketta, jos paasto on jo loppunut tänään -->
                    {#if !fastingEndedToday}
                        <button class="btn btn-primary" on:click={endFast}>Päätä paasto</button>
                    {/if}
                {/if}
            </div>
            <!-- Jos käyttäjä ei ole hoksannut aloittaa paastoa ajoissa, niin tästä voi lisätä koko setin kerralla -->
            {#if fullFastEntry}
                <div class="row">
                    <div class="col-xs-3 col-md-3">
                        <label>Paasto alkaa</label>
                    </div>
                    <div class="col-xs-3 col-md-3">
                        <input type="date" bind:value={fromDateStr} on:change={calculateFast}/>
                    </div>
                    <div class="col-xs-3 col-md-3 sameRow">
                        <select class="form-control hourSelect" bind:value={fromHours} id="fromHourSelect"
                                on:change={calculateFast}>
                            {#each hours as hour}
                                <option value="{hour}">{hour}</option>
                            {/each}
                        </select>
                        :
                        <select class="form-control minuteSelect" bind:value={fromMinutes}
                                id="fromMinuteSelect" on:change={calculateFast}>
                            <option value="0">00</option>
                            <option value="15">15</option>
                            <option value="30">30</option>
                            <option value="45">45</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-3 col-md-3">
                        <label>Paasto loppuu</label>
                    </div>
                    <div class="col-xs-3 col-md-3">
                        <input type="date" bind:value={toDateStr} on:change={calculateFast}/>
                    </div>
                    <div class="col-xs-3 col-md-3 sameRow">
                        <select class="form-control hourSelect" bind:value={toHours} id="endHourSelect"
                                on:change={calculateFast}>
                            {#each hours as hour}
                                <option value="{hour}">{hour}</option>
                            {/each}
                        </select>
                        :
                        <select class="form-control minuteSelect" bind:value={toMinutes} id="endMinuteSelect"
                                on:change={calculateFast}>
                            <option value="00">00</option>
                            <option value="15">15</option>
                            <option value="30">30</option>
                            <option value="45">45</option>
                        </select>
                    </div>
                    <div class="col-xs-3 col-md-3">
                        <div>
                            {#if fastingTime} Paaston kesto: {fastingTime.hours}h  {fastingTime.minutes} min{/if}
                        </div>
                    </div>
                </div>

                <div class="row">
                    {#if fastingTime}
                        <button class="btn btn-primary" on:click={saveFast}>Tallenna</button>
                    {:else }
                        Muokkaa aikaa, jotta voit tallentaa sen.
                    {/if}

                </div>
            {:else}
                <div class="row">
                    <button class="btn btn-secondary" on:click={openFullFastEntry}>Lisään menneen paaston</button>
                </div>
            {/if}

            {#if fastingData && fastingData.length > 0}
                <div class="row">
                    <h3>Menneet paastot</h3>
                </div>
                <div class="row">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th class="" scope="col">Alkoi</th>
                            <th class="" scope="col">Loppui</th>
                            <th class="" scope="col">Tuntia</th>
                            <th class="" scope="col">Toiminnot</th>

                        </tr>
                        </thead>
                        <tbody>
                        {#each fastingData as f}
                            <tr>
                                <td class="">{parseTimestampStrToDateTime(f.startTime)}</td>
                                <td class="">{parseTimestampStrToDateTime(f.endTime)}</td>
                                <td class="">{countHoursAndMinutesFromTimestamps(f.startTime, f.endTime).hours} h
                                    {countHoursAndMinutesFromTimestamps(f.startTime, f.endTime).minutes} min
                                </td>
                                <td class="">
                                    <button type="button" class="btn btn-outline-danger" on:click={() => editFast(f)}>
                                        Muokkaa
                                    </button>
                                    <button type="button" class="btn btn-outline-danger"
                                            on:click={() => deleteFast(f.id)}>Poista
                                    </button>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <h5><i>Keskimäärin: {averageHours} h {averageMinutes} min</i></h5>
                </div>
            {/if}
        </div>
    {:else}
        <div>
            Kirjautumistiedot puuttuvat.
        </div>
    {/if}
</div>
<style>
    .hourSelect {
        width: 60px;
    }

    .minuteSelect {
        width: 60px;
    }

    .sameRow {
        display: contents;
    }
</style>
